import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const ColliOverview = lazy(() => import('./colli-overview/colli-overview'));
const ColliDetail = lazy(() => import('./colli-detail/colli-detail.component'));
const ColliTimerCreate = lazy(() => import('../colli-timer/colli-timer-create/colli-timer-create.component'));
const ColliTimerUpdate = lazy(() => import('../colli-timer/colli-timer-update/colli-timer-update.component'));

export function ColliRoutes() {
    return (
        <Route path='collis'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <ColliOverview />
                    </AsyncComponent>
                }
            />
            <Route
                index
                element={<Navigate to='/collis' />}
            />
            <Route path=':colliId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ColliDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='timers/create'
                    element={
                        <AsyncComponent>
                            <ColliTimerCreate />
                        </AsyncComponent>
                    }
                />
                <Route path='timers'>
                    <Route
                        path=':timerId/update'
                        element={
                            <AsyncComponent>
                                <ColliTimerUpdate />
                            </AsyncComponent>
                        }
                    />
                </Route>
            </Route>
        </Route>
    );
}
